import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Question } from "../components/Question"
import { AppContext } from "../context/AppContext";
import "../style/quiz.css"

export function Quiz() {
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [currentProgress, setcurrentProgress] = useState(50);
    const totalQuestions = appContext.questions !== null ? appContext.questions.results.length : 0;
    

    // if refreshed go back to home
    useEffect(()=>{
        if (appContext.questions === null) {
            navigate("/");
        }
    },[navigate, appContext.questions])

    // set progress bar
    useEffect(()=>{
        setcurrentProgress((1 / totalQuestions)*100);
        // reset quiz stats if repeated
        appContext.updateQuizStats([]);
    },[]);

    const nextQuestion = () => {
        const current = currentQuestion;
        if ((current + 1) < totalQuestions) {
            setCurrentQuestion(current + 1);
            setcurrentProgress(((current + 2) / totalQuestions)*100);
        } else {
            navigate("/results");
        }
    }

    return(
        <div className="quiz">
            <div className="progress">
                <span className="progress-num">{currentQuestion+1} / {totalQuestions}</span>
                <div className="progress-bar-bcg">
                    <div className="progress-bar" style={{width: (currentProgress + "%")}}></div>
                </div>
                
            </div>
            {
                appContext.questions !== null ? 
                    appContext.questions.results.map((question, index)=>(
                        <Question
                            questiontext={question.question}
                            correctAnswer={question.correct_answer}
                            incorrectAnswer1={question.incorrect_answers[0]}
                            incorrectAnswer2={question.incorrect_answers[1]}
                            incorrectAnswer3={question.incorrect_answers[2]}
                            category={question.category}
                            difficulty={question.difficulty}
                            key={index}
                            visible={index === currentQuestion}
                            next={nextQuestion}
                        />
                    )) 
                    : ""  
            }
        </div>
    );
}